module.exports = __webpack_public_path__ + "static/HUB0-a915d8f9cbd0f8744fb01a282dbe18a8.jpg";